import { render, staticRenderFns } from "./AuthButton.vue?vue&type=template&id=1e8ea222&"
import script from "./AuthButton.vue?vue&type=script&lang=ts&"
export * from "./AuthButton.vue?vue&type=script&lang=ts&"
import style0 from "./AuthButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports